export const evaluateSyncCondition = (
  model: any,
  syncCondition?: string
): boolean => {
  if (!syncCondition) return true;

  try {
    return Boolean(new Function('model', `return (${syncCondition})`)(model));
  } catch {
    return false;
  }
};

export const evaluateDynamicPath = (
  path: string,
  changedIndex?: number
): any => {
  try {
    const pathResolver = new Function(`return ${path}`)();
    return typeof pathResolver === 'function'
      ? pathResolver(changedIndex)
      : pathResolver;
  } catch {
    return null;
  }
};